import { apiClient } from '@shared/utils/api-client';
import type { Review } from '../types';

export const REVIEWS_PAGE_SIZE = 25;

export type ReviewsListQuery = {
  page: number;
  limit?: number;
  productId?: number;
};

export type ReviewsListPage = {
  items: Review[];
  total: number;
  page: number;
  limit: number;
};

export const reviewsApi = {
  getAll: async (query: ReviewsListQuery): Promise<ReviewsListPage> => {
    const params = new URLSearchParams();
    params.set('page', String(query.page));
    params.set('limit', String(query.limit ?? REVIEWS_PAGE_SIZE));
    if (query.productId != null) params.set('productId', String(query.productId));
    return apiClient.get<ReviewsListPage>(`/reviews?${params.toString()}`);
  },

  getNewCount: async (): Promise<{ count: number }> => {
    return apiClient.get<{ count: number }>('/reviews/new/count');
  },

  setApproval: async (id: number, approved: boolean): Promise<Review> => {
    return apiClient.patch<Review>(`/reviews/${id}/approval`, { approved });
  },

  reply: async (id: number, text: string): Promise<Review> => {
    return apiClient.post<Review>(`/reviews/${id}/seller-reply`, { text });
  },

  delete: async (id: number): Promise<{ success: boolean }> => {
    return apiClient.delete<{ success: boolean }>(`/reviews/${id}`);
  },
};
